import React from 'react';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import PropTypes from 'prop-types';

import BackButton from './back-button';
import PrimaryActionButton from './primary-action-button';

import style from './style.module.less';

const AutoRoutingConfigurationModalFooter = ({ handleContinueEnablingSmartRouting }) => {
  return (
    <ModalFooter className={style['wizard-modal-footer']}>
      <div className={style['footer-back']}>
        <BackButton disabled={false} />
      </div>
      <div className={style['footer-next']}>
        <ModalFooterCancelButton className={style['cancel-button']} />
        <PrimaryActionButton disabled={false} handleContinueEnablingSmartRouting={handleContinueEnablingSmartRouting} />
      </div>
    </ModalFooter>
  );
};

AutoRoutingConfigurationModalFooter.propTypes = {
  handleContinueEnablingSmartRouting: PropTypes.func.isRequired,
};

export default AutoRoutingConfigurationModalFooter;
